import { ReactElement } from "react";
import * as React from "react";

import { AssetTypes } from "../../../generated/gql/graphql";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  error: boolean;
  onChangeAssetTypes(assetTypes?: AssetTypes): void;
};

export default function AssetTypeSelector(props: Props): ReactElement {
  const { error, onChangeAssetTypes } = props;

  const { strings } = useText(local);
  const options = Object.keys(AssetTypes).map((t) => t);

  return (
    <MetaSelect
      error={error}
      required
      label={strings.label}
      name="value"
      getOptions={options}
      setOption={(v) => onChangeAssetTypes(v["value"])}
      list={options.map((v) => ({ text: v, value: v }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Asset Types",
  },
};
